<script setup lang="ts">
import { computed } from 'vue'
import { Badge } from '@/components/ui/badge'
import { Skeleton } from '@/components/ui/skeleton'
import { searchColorMap } from '@/utils/index'
import { useSubscription } from '@/composables/useSubscription'

type Props = {
  tenantId: string
}

const props = defineProps<Props>()

const { loading, error, subscription, expirationWarning } = useSubscription(props.tenantId)

const badgeText = computed(() => {
  if (error.value || !subscription.value) return 'None'
  if (expirationWarning.value === 'expired') return 'Expired'
  if (expirationWarning.value === 'renew_soon') return 'Renew Soon'
  return 'Active'
})

const badgeColor = computed(() => {
  if (error.value || !subscription.value) return searchColorMap('expired')
  if (expirationWarning.value === 'expired') return searchColorMap('expired')
  if (expirationWarning.value === 'renew_soon') return searchColorMap('renew soon')
  return searchColorMap('active')
})
</script>

<template>
  <Skeleton v-if="loading" class="h-6 w-20" />
  <Badge v-else :class="badgeColor">{{ badgeText }}</Badge>
</template>
